module.exports = __webpack_public_path__ + "static/media/certificat1.2546fdf9.webp";